let count = 0;
const useId = (id, prefix = "ark") => id ? id : `${prefix}-${count++}`;

export { useId };
